module.exports = __webpack_public_path__ + "static/media/list.f8b4a0c9.svg";